import rootLogger from '@/utils/root-logger';
import fetcher from '@/utils/fetcher';

const logger = rootLogger.create('store/modules/survey');

const mutations = {
  setSurveyInfo(state, payload) {
    state.surveyInfo = payload.surveyInfo;
  },

  setSurveyUrl(state, payload) {
    state.surveyUrl = payload.surveyUrl;
  },

  setSurveyAvailability(state, payload) {
    state.surveyAvailability = payload.surveyAvailability;
  }
};
// example:
// POST https://attendeeed1.g2w.test.expertcity.com/survey/take.tmpl
// survey:9077908132315247106
// user:thomas@local-chrome.com
// surveySubmission.surveyKey:9077908132315247106
// surveySubmission.surveyVersion:1501185970905
// surveySubmission.event:4662157284980777730
// surveySubmission.email:thomas@local-chrome.com
// surveySubmission.sessionKey:519194
// webinar:4662157284980777730
// surveySubmission.answers[0].questionKey:7765099
// _surveySubmission.answers[0].selectedOptions:
// surveySubmission.answers[0].selectedOptions:7765100
// _surveySubmission.answers[0].selectedOptions:
// _surveySubmission.answers[0].selectedOptions:
// surveySubmission.submit.button:Submit

const actions = {
  async getSurveyInfo({commit, rootGetters}, payload) {
    const operation = 'getSurveyInfo';
    const webinarKey = payload.webinarKey;
    logger.log(operation, {webinarKey});

    const path = `/api/webinars/${webinarKey}/surveyInfo`;
    const url = rootGetters['g2wEnv/globalUrl'](path);

    let surveyInfo;
    try {
      surveyInfo = await fetcher.fetchJSON(url, {}, {operation, quiet: true});
    } catch (error) {
      if (error.response && error.response.status !== 404) {
        throw error;
      }
      surveyInfo = null;
    }

    commit('setSurveyInfo', { surveyInfo });
    return surveyInfo;
  },

  async makeSurveyUrl(context, payload) {
    const {surveyInfo = {}, sessionKey} = payload;

    try {
      if (!surveyInfo.surveyBaseUrl) {
        return null;
      }

      const url = [
        surveyInfo.surveyBaseUrl,
        encodeURIComponent(payload.email),
        surveyInfo.webinarKey,
        surveyInfo.sessionKey || sessionKey
      ].join('/');

      return url;
    } catch (error) {
      return null; // no survey
    }
  },

  async checkAvailability({state, commit, dispatch}, payload) {
    // sessionKey must be retrieved earlier because it will be missing after session end
    const {sessionKey} = state.surveyInfo || {};
    let surveyAvailability = false;
    const surveyInfo = await dispatch('getSurveyInfo', payload);
    commit('setSurveyInfo', {surveyInfo});

    if (surveyInfo && surveyInfo.displayAtSessionEnd) {
      const surveyUrl = await dispatch('getSurveyUrl', {surveyInfo, sessionKey}, {root: true});
      commit('setSurveyUrl', {surveyUrl});

      if (surveyUrl) {
        // would be good to pre-fetch surveyUrl but CORS issue
        surveyAvailability = true;
      }
    }

    commit('setSurveyAvailability', {surveyAvailability});
    return surveyAvailability;
  }
};

const state = () => ({
  surveyInfo: null,
  surveyUrl: null,
  surveyAvailability: null
});

export default {
  namespaced: true,
  mutations,
  actions,
  state
};
